import NextHead from 'next/head'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useStore } from '@bluheadless/ui-logic/src/providers/store'
import { useCurrency } from '@bluheadless/ui-logic/src/providers/currency'
import { mediaUrl } from '@bluheadless/ui-logic/src/assets'
import { useMemo, useCallback } from 'react'

const Category = ({ items }) => {
	const { baseUrl, path } = useStore()
	const { currency } = useCurrency()
	const {
		catalog: { urlKeySuffix },
	} = useConfig()

	const transformAssets = useCallback((assets) => {
		const imageUrls = []

		assets?.map(({ image }) => {
			imageUrls.push(mediaUrl(image))
		})

		return imageUrls
	}, [])

	const categoryItems = useMemo(
		() =>
			items.length > 0
				? items.map(({ name, assets, urlKey, prices }, index) => ({
						position: index + 1,
						item: {
							'@type': 'Product',
							name: name,
							image: transformAssets(assets),
							url: baseUrl + path + '/' + urlKey + urlKeySuffix,
							offers: {
								'@type': 'AggregateOffer',
								lowPrice: prices?.min,
								highPrice: prices?.max,
								priceCurrency: currency,
							},
						},
				  }))
				: [],
		[transformAssets, baseUrl, path, urlKeySuffix, currency]
	)

	return (
		<>
			{categoryItems.length > 0 && (
				<NextHead>
					<script
						type="application/ld+json"
						dangerouslySetInnerHTML={{
							__html: JSON.stringify({
								'@context': 'https://schema.org',
								'@type': 'ItemList',
								itemListElement: categoryItems,
							}),
						}}
					/>
				</NextHead>
			)}
		</>
	)
}

export default Category
